export default "__VITE_ASSET__CddDMCHm__"